import React from 'react';
import {FlexBox} from "../ui/styled";
import {AI_SCORE_BAD, AI_SCORE_GOOD, AI_SCORE_PERFECT, AI_SCORE_VERY_BAD} from "../../styled/scoreColor";
import {useTranslation} from "react-i18next";
import styled from "styled-components";

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
`;
const MasterHeaderSection = styled(HeaderSection)`
  margin-bottom: 20px;
`;

const BarBox = styled.div`
  width: fit-content;
  position: relative;
`;
const Bar = styled.div`
  position: absolute;
  bottom: 2px;
  width: 100%;
  height: 4px;
  background-color: ${props => props.theme.color.green_100};
  opacity: 0.3;
`;
const HeaderText = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: ${props => props.theme.color.dark_100};
  font-weight: bold;
`;
const HeaderExplainText = styled.span`
  color: ${props => props.theme.color.font_7F_89};
  font-size: 12px;
  line-height: 17px;
  white-space: pre-wrap;
  margin-top: 10px;
  margin-bottom: 20px;
`;

const ScoreSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const ScoreEmptyBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 20px;
  font-weight: bold;
  background-color: ${props => props.scoreColor};
  font-size: 12px;
  line-height: 17px;
  color: #fff;
  border-radius: 3px;
  margin-right: 10px;
`;

const MasterEmptyBox = styled.div`
  font-size: 12px;
  color: #fff;
  width: 28px;
  height: 20px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${_ => AI_SCORE_GOOD};
`;
const ScoreExplainText = styled.span`
  flex: 1;
  color: ${props => props.theme.color.dark_100};
  font-size: 12px;
  font-weight: 500;
  line-height: 17px;
  white-space: pre-wrap;
`;

const MasterExplainText = styled(ScoreExplainText)`
  margin-left: 6px;
`;

const TeamLuckExplainText = styled(ScoreExplainText)`
  margin-left: 10px;
`;


const Explain = ({children}) => {
    return (
        <div>
            {children}
        </div>
    );
};

const AIScore = () => {
    const {t} = useTranslation()
    return (
        <div>
            <HeaderSection>
                <BarBox>
                    <HeaderText> {t("explain.aiScoreHeader")}</HeaderText>
                    <Bar/>
                </BarBox>
                <HeaderExplainText>{t('explain.aiScoreExplain')}</HeaderExplainText>
            </HeaderSection>
            <HeaderSection>
                <BarBox>
                    <HeaderText> {t("explain.aiCharHeader")}</HeaderText>
                    <Bar/>
                </BarBox>
                <HeaderExplainText>{t('explain.aiCharExplain')}</HeaderExplainText>
            </HeaderSection>
            <ScoreSection>
                <FlexBox>
                    <ScoreEmptyBox scoreColor={AI_SCORE_PERFECT}>100 +</ScoreEmptyBox>
                    <ScoreExplainText>{t('explain.perfect')}</ScoreExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <ScoreEmptyBox scoreColor={AI_SCORE_PERFECT}>75~100</ScoreEmptyBox>
                    <ScoreExplainText>{t('explain.veryGood')}</ScoreExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <ScoreEmptyBox scoreColor={AI_SCORE_GOOD}>50~74</ScoreEmptyBox>
                    <ScoreExplainText>{t('explain.good')}</ScoreExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <ScoreEmptyBox scoreColor={AI_SCORE_BAD}>25~49</ScoreEmptyBox>
                    <ScoreExplainText>{t('explain.bad')}</ScoreExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <ScoreEmptyBox scoreColor={AI_SCORE_VERY_BAD}>0~24</ScoreEmptyBox>
                    <ScoreExplainText>{t('explain.veryBad')}</ScoreExplainText>
                </FlexBox>
            </ScoreSection>
        </div>
    )
}

const TeamLuckImgBox = styled.div``;

const TeamLuck = () => {
    const {t} = useTranslation()

    return (
        <div>
            <HeaderSection>
                <BarBox>
                    <HeaderText>{t('explain.teamLuck.header')}</HeaderText>
                    <Bar/>
                </BarBox>
                <HeaderExplainText>{t('explain.teamLuck.explain')}</HeaderExplainText>
            </HeaderSection>
            <ScoreSection>
                <FlexBox>
                    <TeamLuckImgBox>
                        <img
                            src={`./images/icon_teamluck_godlike.gif`}
                            width={16}
                            height={16}
                            alt={''}
                        />
                    </TeamLuckImgBox>
                    <TeamLuckExplainText>{t('explain.teamLuck.godLike')}</TeamLuckExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <TeamLuckImgBox>
                        <img
                            src={`./images/icon_teamluck_solid.svg`}
                            width={16}
                            height={16}
                            alt={''}
                        />
                    </TeamLuckImgBox>
                    <TeamLuckExplainText>{t('explain.teamLuck.solid')}</TeamLuckExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <TeamLuckImgBox>
                        <img
                            src={`./images/icon_teamluck_balanced.svg`}
                            width={16}
                            height={16}
                            alt={''}
                        />
                    </TeamLuckImgBox>
                    <TeamLuckExplainText>{t('explain.teamLuck.balanced')}</TeamLuckExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <TeamLuckImgBox>
                        <img
                            src={`./images/icon_teamluck_messy.svg`}
                            width={16}
                            height={16}
                            alt={''}
                        />
                    </TeamLuckImgBox>
                    <TeamLuckExplainText>{t('explain.teamLuck.messy')}</TeamLuckExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <TeamLuckImgBox>
                        <img
                            src={`./images/icon_teamluck_doomed.gif`}
                            width={16}
                            height={16}
                            alt={''}
                        />
                    </TeamLuckImgBox>
                    <TeamLuckExplainText>{t('explain.teamLuck.doomed')}</TeamLuckExplainText>
                </FlexBox>
            </ScoreSection>
        </div>
    )
}

const Master = () => {
    const {t} = useTranslation()
    return (
        <div>
            <MasterHeaderSection>
                <BarBox>
                    <HeaderText> {t("explain.masterHeader")}</HeaderText>
                    <Bar/>
                </BarBox>
            </MasterHeaderSection>
            <ScoreSection>
                <FlexBox>
                    <MasterEmptyBox>1</MasterEmptyBox>
                    <MasterExplainText>{t('explain.master1')}</MasterExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <MasterEmptyBox>2</MasterEmptyBox>
                    <MasterExplainText>{t('explain.master2')}</MasterExplainText>
                </FlexBox>
                <FlexBox margin={'10px 0 0 0'}>
                    <MasterEmptyBox>3</MasterEmptyBox>
                    <MasterExplainText>{t('explain.master3')}</MasterExplainText>
                </FlexBox>
            </ScoreSection>
        </div>
    )
}

const CircleQuestion = styled.div`
  margin-right: 4px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;
  border-radius: 100%;
  background-color: ${props => props.theme.color.green_100};
  color: ${props => props.theme.color.white_400};
  font-family: Pretendard;
  font-weight: 600;
  font-size: 10px;
  line-height: 150%;
  text-align: center;

`;

const ChallengeHeaderText = styled.div`
  font-family: Pretendard;
  font-weight: 600;
  font-size: 10px;
  line-height: 150%;
  color: ${props => props.theme.color.dark_100};
`;
const ChallengeHeaderSubText = styled.div`
  font-family: Pretendard;
  font-weight: 400;
  font-size: 10px;
  line-height: 150%;
  color: ${props => props.theme.color.dark_200};
`;
const GreenNumberBox = styled.div`
  width: 18px;
  height: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 10px;
  line-height: 150%;
  background-color: ${props => props.theme.color.green_100};
  color: ${props => props.theme.color.white_400};
  margin-right: 4px;
`;
const ChallengeInfoText = styled.div`
  font-family: Pretendard;
  font-weight: 400;
  font-size: 10px;
  line-height: 150%;
  color: ${props => props.theme.color.dark_100};
`;
const Challenge = () => {
    return (
        <div>
            <HeaderSection>
                <FlexBox>
                    <CircleQuestion>?</CircleQuestion>
                    <ChallengeHeaderText>
                        CHALLENGE 등재조건
                    </ChallengeHeaderText>
                </FlexBox>
                <FlexBox>
                    <ChallengeHeaderSubText>
                        CHALLENGE 는 S14~S15 최고 티어 GM 800 이상의 티어 참가자 50인의 그룹입니다.
                        순위 산정 방식 : 콘텐츠 진행 기간 내 가장 높은 티어를 달성한 순서로 순위 산정
                    </ChallengeHeaderSubText>
                </FlexBox>
                <FlexBox margin={'8px 0 0 0'}>
                    <ChallengeHeaderText>
                        동률 기준
                    </ChallengeHeaderText>
                </FlexBox>
                <FlexBox margin={'4px 0 0 0'}>
                    <GreenNumberBox>1</GreenNumberBox>
                    <ChallengeInfoText>
                        기간 내 먼저 달성한 플레이어 우선(공통)
                    </ChallengeInfoText>
                </FlexBox>
                <FlexBox margin={'4px 0 0 0'}>
                    <GreenNumberBox>2</GreenNumberBox>
                    <ChallengeInfoText>
                        경기수가 적은 플레이어 > 전체 승률이 높은 플레이어 우선
                    </ChallengeInfoText>
                </FlexBox>
            </HeaderSection>
        </div>
    )
}
const Expert = () => {
    return (
        <div>
            <HeaderSection>
                <FlexBox>
                    <CircleQuestion>?</CircleQuestion>
                    <ChallengeHeaderText>
                        EXPERT 등재조건
                    </ChallengeHeaderText>
                </FlexBox>
                <FlexBox>
                    <ChallengeHeaderSubText>
                        EXPERT 는 S1 4~S15 최고 티어 D~M799 이하 티어의 참가자 50인의 그룹입니다.
                        순위 산정 방식 : 콘텐츠 진행 기간 내 목표까지 남은 LP가 가장 적은 플레이어를 순서로 순위 산정
                    </ChallengeHeaderSubText>
                </FlexBox>
                <FlexBox margin={'8px 0 0 0'}>
                    <ChallengeHeaderText>
                        동률 기준
                    </ChallengeHeaderText>
                </FlexBox>
                <FlexBox margin={'4px 0 0 0'}>
                    <GreenNumberBox>1</GreenNumberBox>
                    <ChallengeInfoText>
                        기간 내 정규 경기수 50 경기를 채운 플레이어 우선
                    </ChallengeInfoText>
                </FlexBox>
                <FlexBox margin={'4px 0 0 0'}>
                    <GreenNumberBox>2</GreenNumberBox>
                    <ChallengeInfoText>
                        기간 내 목표 티어를 먼저 달성한 플레이어 우선(공통)
                    </ChallengeInfoText>
                </FlexBox>
                <FlexBox margin={'4px 0 0 0'}>
                    <GreenNumberBox>3</GreenNumberBox>
                    <ChallengeInfoText>
                        경기수가 적은 플레이어 > 승률이 높은 플레이어 > 마감 티어가 높은 플레이어 우선
                    </ChallengeInfoText>
                </FlexBox>
            </HeaderSection>
        </div>
    )
}

const Potential = () => {
    return (
        <div>
            <HeaderSection>
                <FlexBox>
                    <CircleQuestion>?</CircleQuestion>
                    <ChallengeHeaderText>
                        POTENTIAL 등재조건
                    </ChallengeHeaderText>
                </FlexBox>
                <FlexBox>
                    <ChallengeHeaderSubText>
                        POTENTIAL 은 CHALLENGE, EXPERT 기준에 포함되지 않는 참가자 50인의 그룹입니다.
                        순위 산정 방식 : 콘텐츠 진행 기간 내 목표까지 남은 LP가 가장 적은 플레이어를 순서로 순위 산정
                    </ChallengeHeaderSubText>
                </FlexBox>
                <FlexBox margin={'8px 0 0 0'}>
                    <ChallengeHeaderText>
                        동률 기준
                    </ChallengeHeaderText>
                </FlexBox>
                <FlexBox margin={'4px 0 0 0'}>
                    <GreenNumberBox>1</GreenNumberBox>
                    <ChallengeInfoText>
                        기간 내 정규 경기수 50 경기를 채운 플레이어 우선
                    </ChallengeInfoText>
                </FlexBox>
                <FlexBox margin={'4px 0 0 0'}>
                    <GreenNumberBox>2</GreenNumberBox>
                    <ChallengeInfoText>
                        기간 내 목표 티어를 먼저 달성한 플레이어 우선(공통)
                    </ChallengeInfoText>
                </FlexBox>
                <FlexBox margin={'4px 0 0 0'}>
                    <GreenNumberBox>3</GreenNumberBox>
                    <ChallengeInfoText>
                        경기수가 적은 플레이어 > 승률이 높은 플레이어 > 마감 티어가 높은 플레이어 우선
                    </ChallengeInfoText>
                </FlexBox>
            </HeaderSection>
        </div>
    )
}
Explain.AIScore = AIScore
Explain.TeamLuck = TeamLuck
Explain.Master = Master
Explain.Challenge = Challenge
Explain.Expert = Expert
Explain.Potential = Potential

export default Explain;

